import { SchemaSMSSharedModels } from '@frontend/api-messaging';
import { TEXT_WRITEBACKS_RELATED_ID_TYPE } from '../constants';

export const messageHasTextWriteback = (relatedIds: SchemaSMSSharedModels.RelatedID[]) =>
  relatedIds.some((item) => item.type === TEXT_WRITEBACKS_RELATED_ID_TYPE);
